import {ArrowRight, ShieldCheck, Sparkles, TrendingDown} from 'lucide-react'

const HERO_IMG = 'https://static.lumi.new/c9/c988ab28a96964df2cdd7b1f08eafbcc.png'

function Hero() {
  return (
    <section id="top" className="relative overflow-hidden pt-[72px]">
      {/* Ambient glow + grid */}
      <div className="absolute inset-0 grid-glow opacity-60" aria-hidden="true" />
      <div
        className="absolute -top-40 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full blur-[130px] opacity-30"
        style={{ background: 'radial-gradient(circle, #2563eb 0%, transparent 70%)' }}
        aria-hidden="true"
      />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-20 lg:pt-24 lg:pb-28 grid lg:grid-cols-[1.1fr_0.9fr] gap-12 lg:gap-16 items-center">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full border border-blue-500/30 bg-blue-500/10 px-4 py-1.5 text-[13px] font-medium text-blue-300">
            <Sparkles className="w-3.5 h-3.5" aria-hidden="true" />
            Science-backed · Katch-McArdle & Mifflin-St Jeor
          </span>

          <h1 className="font-display mt-6 text-[44px] leading-[1.05] sm:text-[56px] lg:text-[64px] font-bold tracking-[-0.03em] text-white">
            I want to get ripped.
            <br />
            <span className="text-blue-500">Now you have the math.</span>
          </h1>

          <p className="mt-6 text-[17px] sm:text-[18px] leading-relaxed text-slate-400 max-w-xl">
            The premium scientific Shred Calculator that turns your numbers into a lean and ripped
            body blueprint — exact calories, macros, hydration, and a shred speed timeline to get a
            ripped body without wasting muscle.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-3.5">
            <a
              href="#calculator"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-blue-600 px-7 py-3.5 text-[15px] font-semibold text-white hover:bg-blue-500 transition-colors shadow-[0_8px_30px_rgba(37,99,235,0.35)]"
            >
              Calculate My Shred
              <ArrowRight className="w-5 h-5" aria-hidden="true" />
            </a>
            <a
              href="#guide"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-white/15 bg-white/[0.03] px-7 py-3.5 text-[15px] font-semibold text-white hover:bg-white/[0.08] transition-colors"
            >
              How to shred muscle fat
            </a>
          </div>

          <dl className="mt-12 grid grid-cols-3 gap-6 max-w-lg">
            {[
              { k: '5', label: 'Lean formulas combined' },
              { k: '15-25%', label: 'Calibrated deficits' },
              { k: '100%', label: 'Free & private' },
            ].map((s) => (
              <div key={s.label}>
                <dt className="font-mono text-2xl sm:text-3xl font-bold text-white">{s.k}</dt>
                <dd className="mt-1 text-[12px] uppercase tracking-wide text-slate-500">
                  {s.label}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        {/* Hero visual */}
        <div className="relative">
          <div className="relative rounded-[28px] overflow-hidden border border-white/10 shadow-[0_30px_80px_rgba(0,0,0,0.6)]">
            <img
              src={HERO_IMG}
              alt="Shredded bodybuilder torso with athletic muscle definition under dramatic blue studio lighting"
              className="w-full h-full object-cover"
              loading="eager"
              width={800}
              height={1000}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a0c10] via-transparent to-transparent" />

            {/* Floating stat cards */}
            <div className="absolute top-5 left-5 rounded-2xl bg-[#0a0c10]/80 backdrop-blur-md border border-white/10 px-4 py-3">
              <div className="flex items-center gap-2 text-blue-400 text-[11px] font-medium uppercase tracking-wide">
                <TrendingDown className="w-3.5 h-3.5" aria-hidden="true" /> Daily Target
              </div>
              <div className="font-mono text-2xl font-bold text-white mt-1">2,140 kcal</div>
            </div>

            <div className="absolute bottom-5 right-5 rounded-2xl bg-[#0a0c10]/80 backdrop-blur-md border border-white/10 px-4 py-3">
              <div className="flex items-center gap-2 text-emerald-400 text-[11px] font-medium uppercase tracking-wide">
                <ShieldCheck className="w-3.5 h-3.5" aria-hidden="true" /> Muscle Preserved
              </div>
              <div className="font-mono text-2xl font-bold text-white mt-1">213g protein</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
